import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, timeout } from 'rxjs/operators';
import { Estado } from 'src/app/components/affiliates/pages/affiliates-detail-process/estado-solicitud.enum';
import { SolicitudAfiliacion } from "src/app/core/models/request/solicitud-afiliacion";
import { environment } from '../../../../environments/environment';
import { DataFileMassProcess } from '../../models/affiliation/data-file-mass-process';
import { FilterAffiliateProcess } from '../../models/affiliation/filter-affiliate-process';
import { IAffiliatesProcess, IAffiliationData } from '../../models/affiliation/iaffiliate-process';
import { HttpHeadersPortal, HttpService } from './../../http/http.service';
import { GeneralResponse } from './../../models/general-response/general-response';
import { ManejadorArchivos } from '../../helpers/archivos/manejador-archivos.service';
import { ModalVariadoService } from '../modal-variado/modal-variado.service';
import { mensajeModalListadoTrabajadores } from '../../enums/mensaje-modal-listado-trabajadores.enum';

@Injectable({
  providedIn: 'root'
})
export class AffiliationService {
  idModal = "m-load";

  constructor(
    private _ModalVariadoService: ModalVariadoService,
    private httpService: HttpService) { }

  createAffiliation(dataAffiliation: SolicitudAfiliacion): Observable<GeneralResponse<any>> {

    return this.httpService.post(
      environment.GESTOR_SOLICITUDES.API_CLIENTE.PREFIJO_URL,
      '/solicitudes',
      dataAffiliation
    ).pipe(
      map((response) => {
        return response as GeneralResponse<any>;
      })
    );

  }

  uploadFile(url: string, file: File, name: string, size: string, tidEmpleador: string, idEmpleador: string, dig: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', name);
    formData.append('size', size);
    formData.append('tidEmpleador', tidEmpleador);
    formData.append('idEmpleador', idEmpleador);
    formData.append('dig', dig);


  return this.httpService.put(
    environment.AFILIACION_MASIVA.API_URL,
    '/archivos/cargar',
    formData
  ).pipe(
    map((response) => {
      return response as GeneralResponse<IValidateFile>;
    }),
    timeout(3600000)
  );

  }

  processData(dataFile: DataFileMassProcess): Observable<any> {
    return this.httpService.post(
      environment.AFILIACION_MASIVA.API_URL,
      '/archivos/processFile',
      dataFile
    ).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getTopAffiliations(nit: string, quantity: string): Observable<Array<IAffiliatesProcess>> {
    const params = {
      nit,
      cantidad: quantity
    };

    return this.httpService.get<GeneralResponse<Array<IAffiliatesProcess>>>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/top/afiliaciones/mes/actual',
      params
    ).pipe(map((response => response.body)));

  }

  getDetailAffiliation(affiliatesProcess: IAffiliatesProcess): Observable<IAffiliationData> {
    return this.httpService.post<GeneralResponse<IAffiliationData>>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/afiliaciones/detalle',
      affiliatesProcess
    ).pipe(map((response => response.body)));
  }

  getExcelAffiliationMas(affiliatesProcess: IAffiliatesProcess): Observable<string> {
    return this.httpService.post<GeneralResponse<string>>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/afiliaciones/excel',
      affiliatesProcess
    ).pipe(map((response => response.body)));
  }

  getDataAffiliationsByFilters(filterAffiliateProcess: FilterAffiliateProcess): Observable<Array<IAffiliatesProcess>> {
    return this.httpService.post<GeneralResponse<Array<IAffiliatesProcess>>>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/afiliaciones',
      filterAffiliateProcess
    ).pipe(map((response => response.body)));
  }

  getSolicitudesByEmpresa(numeroIdentidadEmpresa: string, limit: number): Observable<IAffiliatesProcess[]> {
    const params = {
      numeroIdentidadEmpresa: numeroIdentidadEmpresa,
      maxRegistros: limit.toString()
    };
    return this.httpService.get<IAffiliatesProcess[]>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/api/solicitudes/fecha',
      params
    );
  }

  getRequestsByFilters(filterAffiliateProcess: FilterAffiliateProcess): Observable<IAffiliatesProcess[]> {
    const estadoString = Estado[filterAffiliateProcess.estado as keyof typeof Estado] || '';
    const estadoFinal = estadoString.toString();
    const params = { radicado: String(filterAffiliateProcess.radicado)
      ,fechaSeleccionada: filterAffiliateProcess.fecha,
      estado:estadoFinal};

    return this.httpService.get<IAffiliatesProcess[]>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      '/api/solicitudes/filtrar',
      params
    );
  }

  detallesFiltro(filterAffiliateProcess: IAffiliatesProcess): Observable<IAffiliatesProcess> {
    const params = { id: String(filterAffiliateProcess.id) };

    return this.httpService.get<IAffiliatesProcess>(
      environment.AFILIACION_MASIVA.HISTORIAL_AFILIACION_API_URL,
      `/api/solicitudes/DetalleFiltro`,
       params
    );
  }

  async descargarListadoDeTrabajadoresVigentes(
    tipoIdentidadEmpresa: string,
    numeroIdentidadEmpresa: string,
    adjuntoBeneficiario: boolean = false,
    emailDestinatario: string
  ) {
    const baseUrl = environment.GESTOR_SOLICITUDES.API_CONSULTAS_V2.PREFIJO_URL;
    const urlReporte = environment.GESTOR_SOLICITUDES.API_CONSULTAS_V2.AFILIADOS_ENDPOINT;

    const fullUrl = `${baseUrl}${urlReporte}`;

    const queryString = `/async?tipoIdentidad=${encodeURIComponent(tipoIdentidadEmpresa)}&numeroIdentidad=${encodeURIComponent(numeroIdentidadEmpresa)}&adjuntoBeneficiario=${adjuntoBeneficiario}&emailDestinatario=${encodeURIComponent(emailDestinatario)}`;
    const headers: HttpHeadersPortal = this.httpService.getGlobalHeaders();

    try {
      this._ModalVariadoService.modalConfirmacion(mensajeModalListadoTrabajadores.confirmacionYEnvio);
      await this.httpService.post<void>(fullUrl,  queryString, null, null, headers).toPromise();
    } catch (error) {
      this._ModalVariadoService.modalError(mensajeModalListadoTrabajadores.error+ error);
      console.error("Error al iniciar el proceso:", error);
    }
  }

}

